(function () {
  if (customElements.get('fbk-search-bar')) return;


  function setHidden(element, hidden) {
    if (element) element.hidden = hidden;
  }

  function routeRoot() {
    return ((window.Shopify?.routes?.root) || '/').replace(/\/?$/, '/');
  }

  function parseFragment(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  class FbkSearchBar extends HTMLElement {
    connectedCallback() {
      var q = this.querySelector.bind(this);
      this.form = q('[data-fbk-search-form]');
      this.input = q('[data-fbk-search-input]');
      this.clearBtn = q('[data-fbk-search-clear]');
      this.closeBtn = q('[data-fbk-search-close]');
      this.backdrop = q('[data-fbk-search-backdrop]');
      this.panel = q('[data-fbk-search-panel]');
      this.loading = q('[data-fbk-search-loading]');
      this.resultsContainer = q('[data-fbk-search-results-container]');
      this.resultsRoot = q('[data-fbk-search-results]');
      this.idle = q('[data-fbk-search-idle]');
      if (!this.form || !this.input || !this.panel || !this.resultsRoot) return;

      this.cache = new Map();
      this.fallbackUrl = this.dataset.fbkSearchFallbackUrl || '';
      this.fallbackHeading = this.dataset.fbkSearchFallbackHeading || '';
      this.fallbackMarkup = null;
      this.bestsellerUrl = this.dataset.fbkSearchBestsellerUrl || '';
      this.bestsellerHeading = this.dataset.fbkSearchBestsellerHeading || '';
      this.productHandle = this.dataset.fbkSearchProductHandle || '';
      this.activeIndex = -1;
      this.isOpen = false;
      this.suppressFocusOpen = false;
      this.mobileQuery = window.matchMedia('(max-width: 1149px)');
      this.eventController = new AbortController();
      var opts = { signal: this.eventController.signal };

      this.input.addEventListener('input', this.onInput.bind(this), opts);
      this.input.addEventListener('focus', this.onFocus.bind(this), opts);
      this.input.addEventListener('keydown', this.onInputKeydown.bind(this), opts);
      this.addEventListener('keydown', this.onShellKeydown.bind(this), opts);
      this.addEventListener('click', this.onShellClick.bind(this), opts);
      this.form.addEventListener('submit', this.onSubmit.bind(this), opts);
      this.clearBtn?.addEventListener('click', this.onClear.bind(this), opts);
      this.closeBtn?.addEventListener('click', this.onClose.bind(this), opts);
      this.backdrop?.addEventListener('click', this.onClose.bind(this), opts);
      document.addEventListener('pointerdown', this.onDocumentPointerDown.bind(this), opts);
      this.mobileQuery.addEventListener('change', this.updateViewportState.bind(this), opts);
      window.addEventListener('resize', this.updateViewportState.bind(this), opts);

      this.idle?.querySelectorAll('[data-fbk-search-option]').forEach((option, index) => {
        if (!option.id) option.id = 'fbk-search-popular-' + index;
      });
      if (this.productHandle) this.recordRecentProduct(this.productHandle);
      this.syncClearButton();
    }

    disconnectedCallback() {
      this.eventController?.abort();
      this.fetchController?.abort();
      window.clearTimeout(this.debounceTimer);
      this.isOpen = false;
      this.updateViewportState();
    }

    getQuery() {
      return this.input.value.trim();
    }

    isCurrent(key) {
      return key === this.getQuery().toLocaleLowerCase();
    }

    getRecentHandles() {
      try {
        var list = JSON.parse(window.localStorage.getItem('fbk_recent') || '[]');
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    getIdleRecentHandles() {
      return this.getRecentHandles().filter((handle) => handle !== this.productHandle).slice(0, 2);
    }

    writeRecentHandles(list) {
      try {
        window.localStorage.setItem('fbk_recent', JSON.stringify(list.slice(0, 10)));
      } catch (error) {}
    }

    recordRecentProduct(handle) {
      this.writeRecentHandles([handle].concat(this.getRecentHandles().filter((h) => h !== handle)));
    }

    search(query, immediate) {
      window.clearTimeout(this.debounceTimer);
      this.fetchController?.abort();

      var key = query.toLocaleLowerCase();
      if (this.cache.has(key)) {
        this.renderResults(this.cache.get(key));
        return;
      }

      this.showLoading();
      if (immediate) this.fetchResults(query);
      else this.debounceTimer = window.setTimeout(this.fetchResults.bind(this, query), 280);
    }

    onInput() {
      var query = this.getQuery();
      this.syncClearButton();
      this.setActiveOption(-1);

      if (query) return this.search(query);
      window.clearTimeout(this.debounceTimer);
      this.fetchController?.abort();
      if (this.idle) this.openIdle();
      else this.close();
    }

    onFocus() {
      if (this.isOpen || this.suppressFocusOpen) return;
      var query = this.getQuery();
      if (query) this.search(query);
      else this.openIdle();
    }

    onShellClick(event) {
      var suggestion = event.target.closest?.('[data-fbk-search-suggestion]');
      if (!suggestion) {
        if (event.target === this.input) this.onFocus();
        return;
      }

      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var term = (suggestion.dataset.fbkSearchSuggestion || '').trim();
      if (!term) return;

      event.preventDefault();
      this.input.value = term;
      this.syncClearButton();
      this.setActiveOption(-1);
      this.input.focus();
      this.search(term, true);
    }

    async fetchResults(query) {
      var key = query.toLocaleLowerCase();
      if (!this.isCurrent(key)) return;

      this.fetchController?.abort();
      this.fetchController = new AbortController();

      var url = routeRoot() + 'search/suggest?q=' + encodeURIComponent(query) + '&section_id=fbk-search-results' +
        '&resources[type]=query,product&resources[limit]=5&resources[limit_scope]=each' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';

      try {
        var response = await fetch(url, { signal: this.fetchController.signal });
        var responseText = await response.text();
        if (!response.ok) throw new Error(response.status);
        if (!this.isCurrent(key)) return;

        var nextResults = parseFragment(responseText, '[data-fbk-search-results]');
        if (!nextResults) throw new Error('No results fragment');

        var markup = nextResults.outerHTML;
        this.cache.set(key, markup);
        if (this.cache.size > 20) this.cache.delete(this.cache.keys().next().value);
        this.renderResults(markup);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.warn('fbk-search failed');
        if (this.isCurrent(key)) this.close();
      }
    }

    renderResults(markup) {
      var template = document.createElement('template');
      template.innerHTML = markup.trim();
      var nextResults = template.content.querySelector('[data-fbk-search-results]');
      if (!nextResults) {
        this.close();
        return;
      }

      this.resultsRoot.replaceWith(nextResults);
      this.resultsRoot = nextResults;
      setHidden(this.idle, true);
      this.setActiveOption(-1);
      setHidden(this.loading, true);
      setHidden(this.resultsContainer, false);
      this.panel.removeAttribute('aria-busy');
      this.open();
      if (this.resultsRoot.dataset.hasResults !== 'true') this.renderFallback();
    }

    async renderFallback() {
      var slot = this.resultsRoot?.querySelector('[data-fbk-search-fallback-slot]');
      if (!slot || !this.fallbackUrl) return;

      if (this.fallbackMarkup === null) {
        if (!this.fallbackPromise) this.fallbackPromise = this.fetchCollection(this.fallbackUrl);
        this.fallbackMarkup = await this.fallbackPromise;
        slot = this.resultsRoot?.querySelector('[data-fbk-search-fallback-slot]');
        if (!slot) return;
      }
      if (!this.fallbackMarkup) return;

      slot.innerHTML = this.fallbackMarkup;
      this.applyHeading(slot, this.fallbackHeading);
      slot.hidden = false;
    }

    async fetchCollection(url) {
      try {
        var response = await fetch(url);
        var responseText = await response.text();
        if (!response.ok) throw new Error(response.status);
        var fragment = parseFragment(responseText, '[data-fbk-search-fallback]');
        return fragment?.dataset.hasProducts === 'true' ? fragment.innerHTML : '';
      } catch (error) {
        console.warn('fbk-search failed');
        return '';
      }
    }

    applyHeading(section, text) {
      var heading = section.querySelector('[data-fbk-search-fallback-heading]');
      if (!heading) return;
      heading.textContent = text;
      section.setAttribute('aria-labelledby', heading.id);
    }

    openIdle() {
      if (!this.idle || this.getQuery()) return;
      var hasPopularTerms = Boolean(this.idle.querySelector('[data-fbk-search-suggestion]'));
      var hasRecentProducts = this.getIdleRecentHandles().length > 0;
      if (!hasPopularTerms && !this.bestsellerUrl && !hasRecentProducts) {
        this.close();
        return;
      }

      setHidden(this.loading, true);
      setHidden(this.resultsContainer, true);
      this.panel.removeAttribute('aria-busy');
      this.idle.hidden = false;
      this.setActiveOption(-1);
      this.open({ idle: true });
      if (this.idleLoaded) return;
      this.idleLoaded = true;
      var section = this.idle.querySelector('[data-fbk-search-bestsellers]');
      if (section && this.bestsellerUrl) this.loadBestsellers(section);
      this.loadRecent();
    }

    async loadBestsellers(section) {
      section.hidden = false;
      var markup = await this.fetchCollection(this.bestsellerUrl);
      if (!markup) {
        section.hidden = true;
        return;
      }

      var list = section.querySelector('[data-fbk-search-bestsellers-list]');
      list.innerHTML = markup;
      list.querySelectorAll('[data-fbk-search-option]').forEach((option, index) => {
        option.id = 'fbk-search-bestseller-' + index;
        option.removeAttribute('role');
        option.removeAttribute('aria-selected');
      });
      this.applyHeading(section, this.bestsellerHeading);
      setHidden(section.querySelector('[data-fbk-search-bestsellers-loading]'), true);
    }

    async loadRecent() {
      var section = this.idle.querySelector('[data-fbk-search-recent]');
      var list = section?.querySelector('[data-fbk-search-recent-list]');
      var handles = this.getIdleRecentHandles();
      if (!section || !list || !handles.length) return;

      section.hidden = false;
      var items = await Promise.all(handles.map((handle) =>
        fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=fbk-search-recent')
          .then((r) => (r.ok ? r.text() : r.status === 404 ? '' : null))
          .then((html) => (html === null ? null : (html && parseFragment(html, '[data-fbk-search-recent-item]')) || ''))
          .catch(() => null)
      ));

      var missing = [];
      items.forEach((item, index) => {
        if (item?.dataset?.hasProduct === 'true') list.appendChild(item);
        else if (item !== null) missing.push(handles[index]);
      });
      if (missing.length) {
        this.writeRecentHandles(this.getRecentHandles().filter((h) => !missing.includes(h)));
      }

      setHidden(section.querySelector('[data-fbk-search-recent-loading]'), true);
      section.hidden = !list.children.length;
    }

    showLoading() {
      setHidden(this.idle, true);
      setHidden(this.loading, false);
      setHidden(this.resultsContainer, true);
      this.panel.setAttribute('aria-busy', 'true');
      this.open();
    }

    open(options) {
      if (!this.getQuery() && !options?.idle) return;

      this.isOpen = true;
      this.setAttribute('data-open', '');
      this.panel.hidden = false;
      setHidden(this.backdrop, false);
      setHidden(this.closeBtn, false);
      this.input.setAttribute('aria-expanded', 'true');
      document.querySelectorAll('details[is="dropdown-disclosure"][open]').forEach((details) => { details.open = false; });
      this.updateViewportState();
    }

    close(options) {
      this.isOpen = false;
      this.removeAttribute('data-open');
      this.panel.hidden = true;
      this.panel.removeAttribute('aria-busy');
      [this.idle, this.backdrop, this.closeBtn, this.loading].forEach((el) => setHidden(el, true));
      setHidden(this.resultsContainer, false);
      this.input.setAttribute('aria-expanded', 'false');
      this.setActiveOption(-1);
      this.updateViewportState();

      if (options?.restoreFocus) {
        this.suppressFocusOpen = true;
        this.input.focus({ preventScroll: true });
        this.suppressFocusOpen = false;
      }
    }

    onClear() {
      this.input.value = '';
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.focus();
    }

    onClose() {
      this.close({ restoreFocus: true });
    }

    onSubmit(event) {
      if (!this.getQuery()) event.preventDefault();
    }

    onDocumentPointerDown(event) {
      if (this.isOpen && !event.composedPath().includes(this)) this.close();
    }

    syncClearButton() {
      setHidden(this.clearBtn, !this.getQuery());
    }

    getOptions() {
      var root = this.idle && !this.idle.hidden ? this.idle : this.resultsRoot;
      if (!root) return [];
      return [...root.querySelectorAll('[data-fbk-search-option]')].filter((o) => !o.closest('[hidden]'));
    }

    setActiveOption(index) {
      var options = this.getOptions();
      options.forEach((option) => {
        option.removeAttribute('data-fbk-search-active');
        if (this.resultsRoot.contains(option)) option.setAttribute('aria-selected', 'false');
      });
      this.activeIndex = index >= 0 && index < options.length ? index : -1;

      if (this.activeIndex === -1) {
        this.input.removeAttribute('aria-activedescendant');
        return;
      }

      var activeOption = options[this.activeIndex];
      activeOption.setAttribute('data-fbk-search-active', '');
      if (this.resultsRoot.contains(activeOption)) {
        activeOption.setAttribute('aria-selected', 'true');
        this.input.setAttribute('aria-activedescendant', activeOption.id);
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
      activeOption.scrollIntoView({ block: 'nearest' });
    }

    onInputKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        event.preventDefault();
        event.stopPropagation();
        this.close({ restoreFocus: true });
        return;
      }

      if (!this.isOpen) return;
      var options = this.getOptions();
      if (!options.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActiveOption((this.activeIndex + 1) % options.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActiveOption(this.activeIndex <= 0 ? options.length - 1 : this.activeIndex - 1);
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        var option = options[this.activeIndex];
        var link = option.matches('a[href]') ? option : option.querySelector('a[href]');
        (link || option).click();
      }
    }

    onShellKeydown(event) {
      if (!this.isOpen || !this.mobileQuery.matches || event.key !== 'Tab') return;

      var focusable = [...this.querySelectorAll('a[href], button:not([hidden]), input:not([disabled])')]
        .filter((el) => !el.matches('[data-fbk-search-backdrop]') && el.getClientRects().length);
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!first || document.activeElement !== (event.shiftKey ? first : last)) return;
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }

    updateViewportState() {
      var open = this.isOpen, mobile = this.mobileQuery.matches;
      document.body.classList.toggle('fbk-search-open', open);
      var aria = { role: 'dialog', 'aria-modal': 'true', 'aria-label': this.panel.getAttribute('aria-label') || 'Search' };
      Object.keys(aria).forEach((a) => open && mobile ? this.setAttribute(a, aria[a]) : this.removeAttribute(a));
      if (!open) return;
      var f = this.form.getBoundingClientRect();
      var h = this.closest('.shopify-section--header')?.getBoundingClientRect();
      var vars = {
        'panel-top': Math.max(0, f.bottom + (mobile ? 8 : 12)),
        'backdrop-top': Math.max(0, h?.bottom || f.bottom),
        'form-top': f.top,
        'form-height': f.height
      };
      Object.keys(vars).forEach((k) => this.style.setProperty('--fbk-search-' + k, vars[k] + 'px'));
    }
  }

  customElements.define('fbk-search-bar', FbkSearchBar);
})();
